module.exports = __webpack_public_path__ + "img/rosa_sudeck_5.94318980.jpg";